type IdleTaskCallback = (deadline: IdleDeadline | null) => void;
type CancelIdleTask = () => void;

export function scheduleIdleTask(
  callback: IdleTaskCallback,
  options?: { timeout?: number }
): CancelIdleTask {
  if (typeof window.requestIdleCallback === "function") {
    const handle = window.requestIdleCallback(
      (deadline) => callback(deadline),
      options
    );
    return () => window.cancelIdleCallback(handle);
  }

  const timeout = options?.timeout ?? 0;
  const handle = setTimeout(() => callback(null), timeout);
  return () => clearTimeout(handle);
}
